var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "coupon-detail-container" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "coupon-detail-content",
          attrs: {
            "element-loading-text": "获取信息中...",
            "element-loading-spinner": "el-icon-loading",
          },
        },
        [
          _c("div", { staticClass: "status-header" }, [
            _c(
              "div",
              { staticClass: "status-info" },
              [
                _c(
                  "el-tag",
                  {
                    attrs: {
                      type: _vm.getStatusType(_vm.form.status),
                      effect: "dark",
                      size: "medium",
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "status-icon",
                      class: _vm.getStatusIcon(_vm.form.status),
                    }),
                    _vm._v(" " + _vm._s(_vm.getStatusText(_vm.form.status))),
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "coupon-title" }, [
                  _vm._v(_vm._s(_vm.form.name || "优惠券详情")),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _vm.form.status !== 3
              ? _c(
                  "div",
                  { staticClass: "action-btns" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "small",
                          icon: "el-icon-document-copy",
                        },
                        on: { click: _vm.copyLink },
                      },
                      [_vm._v("复制领取链接")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "detail-section" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "info-grid" }, [
              _c("div", { staticClass: "info-item" }, [
                _c("label", { staticClass: "info-label" }, [
                  _vm._v("优惠券ID"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.form.id || "--")),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-item" }, [
                _c("label", { staticClass: "info-label" }, [
                  _vm._v("优惠券名称"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-value highlight" }, [
                  _vm._v(_vm._s(_vm.form.name || "--")),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-item" }, [
                _c("label", { staticClass: "info-label" }, [_vm._v("券类型")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "info-value" },
                  [
                    _vm.form.voucherType === 2
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "success",
                              size: "medium",
                              effect: "dark",
                            },
                          },
                          [_vm._v("消费券")]
                        )
                      : _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "primary",
                              size: "medium",
                              effect: "dark",
                            },
                          },
                          [_vm._v("优惠券")]
                        ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-item" }, [
                _c("label", { staticClass: "info-label" }, [
                  _vm._v("内部备注"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.form.internalRemark || "--")),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-item" }, [
                _c("label", { staticClass: "info-label" }, [
                  _vm._v("优惠方式"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-value" }, [
                  _vm._v(
                    _vm._s(_vm.formatCouponType(_vm.form.couponType) || "--")
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-item" }, [
                _c("label", { staticClass: "info-label" }, [
                  _vm._v("最高优惠"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.formatAmount(_vm.form.maxDiscount))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-item" }, [
                _c("label", { staticClass: "info-label" }, [
                  _vm._v("发放数量"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.form.totalQuantity || "--")),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-item" }, [
                _c("label", { staticClass: "info-label" }, [
                  _vm._v("领用规则"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.formatLimitRule(
                        _vm.form.limitType,
                        _vm.form.limitQuantity
                      ) || "--"
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-item" }, [
                _c("label", { staticClass: "info-label" }, [
                  _vm._v("是否公开"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "info-value" },
                  [
                    _vm.form.isPublic === 1
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "success",
                              size: "medium",
                              effect: "dark",
                            },
                          },
                          [_vm._v("公开")]
                        )
                      : _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "info",
                              size: "medium",
                              effect: "dark",
                            },
                          },
                          [_vm._v("不公开")]
                        ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-item" }, [
                _c("label", { staticClass: "info-label" }, [
                  _vm._v("适用分销客户"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.form.distributionCustomersName || "--")),
                ]),
              ]),
              _vm._v(" "),
              _vm.form.redeemPageUrl
                ? _c("div", { staticClass: "info-item" }, [
                    _c("label", { staticClass: "info-label" }, [
                      _vm._v("领用后跳转页面"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-value" }, [
                      _c(
                        "a",
                        {
                          staticClass: "link-value",
                          attrs: {
                            href: _vm.form.redeemPageUrl,
                            target: "_blank",
                          },
                        },
                        [_vm._v(_vm._s(_vm.form.redeemPageUrl))]
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.form.usableScenarios &&
              _vm.getUsableScenariosText(_vm.form.usableScenarios)
                ? _c("div", { staticClass: "info-item" }, [
                    _c("label", { staticClass: "info-label" }, [
                      _vm._v("可使用场景"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "info-value" },
                      _vm._l(
                        _vm.getUsableScenariosList(_vm.form.usableScenarios),
                        function (scenario, index) {
                          return _c(
                            "el-tag",
                            {
                              key: index,
                              staticStyle: {
                                "margin-right": "10px",
                                "margin-bottom": "8px",
                              },
                              attrs: {
                                size: "medium",
                                type: "info",
                                effect: "dark",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-location-information",
                                staticStyle: { "margin-right": "4px" },
                              }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(scenario) +
                                  "\n            "
                              ),
                            ]
                          )
                        }
                      ),
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "info-item full-width" }, [
                _c("label", { staticClass: "info-label" }, [
                  _vm._v("所属券包"),
                ]),
                _vm._v(" "),
                _vm.form.packageNames
                  ? _c(
                      "div",
                      { staticClass: "info-value" },
                      _vm._l(
                        _vm.form.packageNames.split(","),
                        function (pkgName, index) {
                          return _c(
                            "el-tag",
                            {
                              key: index,
                              staticClass: "package-tag",
                              attrs: {
                                size: "small",
                                effect: "plain",
                                type: "primary",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-collection-tag",
                              }),
                              _vm._v(
                                " " + _vm._s(pkgName.trim()) + "\n            "
                              ),
                            ]
                          )
                        }
                      ),
                      1
                    )
                  : _c("div", { staticClass: "info-value empty-value" }, [
                      _c("i", { staticClass: "el-icon-info-circle" }),
                      _vm._v(" 暂未关联券包\n          "),
                    ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "detail-section" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "info-grid" }, [
              _c("div", { staticClass: "info-item time-item" }, [
                _c("label", { staticClass: "info-label" }, [
                  _vm._v("领券时间"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-value time-value" }, [
                  _c("div", { staticClass: "time-row" }, [
                    _c("i", { staticClass: "el-icon-date time-icon" }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.form.startTime || "--"))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "time-divider" }, [_vm._v("至")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "time-row" }, [
                    _c("i", { staticClass: "el-icon-date time-icon" }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.form.endTime || "--"))]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-item time-item" }, [
                _c("label", { staticClass: "info-label" }, [
                  _vm._v("券有效期"),
                ]),
                _vm._v(" "),
                _vm.form.validityType == 1
                  ? _c("div", { staticClass: "info-value time-value" }, [
                      _c("div", { staticClass: "validity-days" }, [
                        _c("i", { staticClass: "el-icon-timer" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v("领取后 "),
                          _c("b", [_vm._v(_vm._s(_vm.form.validityDays))]),
                          _vm._v(" 天内有效"),
                        ]),
                      ]),
                    ])
                  : _c("div", { staticClass: "info-value time-value" }, [
                      _c("div", { staticClass: "time-row" }, [
                        _c("i", { staticClass: "el-icon-date time-icon" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.form.validityStart || "--")),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "time-divider" }, [
                        _vm._v("至"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "time-row" }, [
                        _c("i", { staticClass: "el-icon-date time-icon" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.form.validityEnd || "--")),
                        ]),
                      ]),
                    ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "detail-section" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "discount-content" }, [
              _vm.form.couponDiscountInfo ||
              (_vm.form.couponDiscount && _vm.form.couponDiscount.length > 0)
                ? _c(
                    "div",
                    { staticClass: "discount-info" },
                    _vm._l(
                      _vm.formatDiscountInfo(
                        _vm.form.couponDiscount,
                        _vm.form.couponType
                      ),
                      function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "discount-item" },
                          [
                            _c("i", { staticClass: "el-icon-price-tag" }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(item))]),
                          ]
                        )
                      }
                    ),
                    0
                  )
                : _c("div", { staticClass: "empty-discount" }, [
                    _c("i", { staticClass: "el-icon-info-circle" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("暂无优惠信息")]),
                  ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "detail-section" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "info-grid" }, [
              _c("div", { staticClass: "info-item" }, [
                _c("label", { staticClass: "info-label" }, [
                  _vm._v("领用链接"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "info-value" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "small",
                          icon: "el-icon-document-copy",
                        },
                        on: { click: _vm.copyLink },
                      },
                      [_vm._v("复制链接")]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-item" }, [
                _c("label", { staticClass: "info-label" }, [
                  _vm._v("优惠券返回链接"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "info-value" },
                  [
                    _vm.form.redeemPageUrl
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "copy",
                                rawName: "v-copy",
                                value: _vm.form.redeemPageUrl,
                                expression: "form.redeemPageUrl",
                              },
                            ],
                            attrs: {
                              type: "primary",
                              size: "small",
                              icon: "el-icon-document-copy",
                            },
                          },
                          [_vm._v("复制链接")]
                        )
                      : _c("span", { staticClass: "empty-value" }, [
                          _c("i", { staticClass: "el-icon-info-circle" }),
                          _vm._v(" 暂无链接"),
                        ]),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "detail-section" }, [
            _vm._m(4),
            _vm._v(" "),
            _c("div", { staticClass: "range-type" }, [
              _c("i", { staticClass: "el-icon-s-flag" }),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.form.applicableRangeTypeDesc || "--")),
              ]),
            ]),
            _vm._v(" "),
            [2, 3].includes(_vm.form.applicableRangeType)
              ? _c(
                  "div",
                  { staticClass: "goods-table" },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.showTableData.list,
                          border: "",
                          stripe: "",
                          size: "small",
                          "max-height": 400,
                          "header-cell-style": {
                            backgroundColor: "#f5f7fa",
                            color: "#606266",
                          },
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            label: "ID",
                            prop: "id",
                            align: "center",
                            width: "80",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "编码",
                            prop: "skuCode",
                            align: "center",
                            width: "120",
                            "show-overflow-tooltip": "",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "名称",
                            prop: "skuName",
                            align: "left",
                            "min-width": "180",
                            "show-overflow-tooltip": "",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "零售价",
                            prop: "otPrice",
                            align: "center",
                            width: "120",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", { staticClass: "price-value" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatAmount(scope.row.otPrice)
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            287418003
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "状态",
                            prop: "listStatusDesc",
                            align: "center",
                            width: "100",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "品牌",
                            prop: "brandName",
                            align: "center",
                            width: "120",
                            "show-overflow-tooltip": "",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "供应商",
                            prop: "supplierName",
                            align: "center",
                            width: "180",
                            "show-overflow-tooltip": "",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-pagination", {
                      staticClass: "pagination",
                      attrs: {
                        "page-sizes": [10, 20, 50, 100],
                        "page-size": _vm.pageData.limit,
                        "current-page": _vm.pageData.page,
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _vm.showTableData.total,
                      },
                      on: {
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange,
                      },
                    }),
                  ],
                  1
                )
              : _vm.form.applicableRangeType == 4
              ? _c(
                  "div",
                  { staticClass: "category-selector" },
                  [
                    _c("el-cascader", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled: true,
                        placeholder: "指定分类",
                        options: _vm.showCateIdOption,
                        props: {
                          children: "child",
                          label: "name",
                          value: "id",
                          multiple: true,
                        },
                      },
                      model: {
                        value: _vm.form.cateIdList,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "cateIdList", $$v)
                        },
                        expression: "form.cateIdList",
                      },
                    }),
                  ],
                  1
                )
              : _c("div", { staticClass: "empty-goods" }, [
                  _c("i", { staticClass: "el-icon-shopping-bag-1" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("全部商品可用")]),
                ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "detail-section" }, [
            _vm._m(5),
            _vm._v(" "),
            _c("div", { staticClass: "info-grid" }, [
              _c("div", { staticClass: "info-item" }, [
                _c("label", { staticClass: "info-label" }, [
                  _vm._v("是否需实名认证"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "info-value" },
                  [
                    _vm.form.requireRealNameAuth === 1
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "success",
                              size: "medium",
                              effect: "dark",
                            },
                          },
                          [_vm._v("是")]
                        )
                      : _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "info",
                              size: "medium",
                              effect: "dark",
                            },
                          },
                          [_vm._v("否")]
                        ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-item" }, [
                _c("label", { staticClass: "info-label" }, [
                  _vm._v("是否启用压测模式"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "info-value" },
                  [
                    _vm.form.enableStressTest === 1
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "warning",
                              size: "medium",
                              effect: "dark",
                            },
                          },
                          [_vm._v("是")]
                        )
                      : _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "info",
                              size: "medium",
                              effect: "dark",
                            },
                          },
                          [_vm._v("否")]
                        ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-item" }, [
                _c("label", { staticClass: "info-label" }, [
                  _vm._v("是否启用参数加密"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "info-value" },
                  [
                    _vm.form.enableParamEncryption === 1
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "warning",
                              size: "medium",
                              effect: "dark",
                            },
                          },
                          [_vm._v("是")]
                        )
                      : _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "info",
                              size: "medium",
                              effect: "dark",
                            },
                          },
                          [_vm._v("否")]
                        ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-item" }, [
                _c("label", { staticClass: "info-label" }, [
                  _vm._v("是否地区限制"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "info-value" },
                  [
                    _vm.form.isAreaRestricted === 1
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "warning",
                              size: "medium",
                              effect: "dark",
                            },
                          },
                          [_vm._v("是")]
                        )
                      : _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "info",
                              size: "medium",
                              effect: "dark",
                            },
                          },
                          [_vm._v("否")]
                        ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm.form.isAreaRestricted === 1 && _vm.form.areaRestrictionScope
                ? _c("div", { staticClass: "info-item full-width" }, [
                    _c("label", { staticClass: "info-label" }, [
                      _vm._v("地区限制范围"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-value" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-bottom": "12px",
                            color: "#606266",
                            "font-size": "14px",
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatAreaRestriction(
                                  _vm.form.areaRestrictionScope
                                )
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.getAreaRestrictionList(_vm.form.areaRestrictionScope)
                        .length > 0
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "margin-top": "12px",
                                "padding-top": "12px",
                                "border-top": "1px solid #EBEEF5",
                              },
                            },
                            _vm._l(
                              _vm.getAreaRestrictionList(
                                _vm.form.areaRestrictionScope
                              ),
                              function (areaPath, index) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: index,
                                    staticStyle: {
                                      "margin-right": "8px",
                                      "margin-bottom": "8px",
                                    },
                                    attrs: { size: "small", type: "info" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(areaPath) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }
                            ),
                            1
                          )
                        : _vm._e(),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "info-item" }, [
                _c("label", { staticClass: "info-label" }, [
                  _vm._v("是否与福利卡互斥"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "info-value" },
                  [
                    _vm.form.excludeWelfareCard === 1
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "warning",
                              size: "medium",
                              effect: "dark",
                            },
                          },
                          [_vm._v("是")]
                        )
                      : _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "info",
                              size: "medium",
                              effect: "dark",
                            },
                          },
                          [_vm._v("否")]
                        ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-item" }, [
                _c("label", { staticClass: "info-label" }, [
                  _vm._v("是否与其他优惠互斥"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "info-value" },
                  [
                    _vm.form.excludeOtherDiscounts === 1
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "warning",
                              size: "medium",
                              effect: "dark",
                            },
                          },
                          [_vm._v("是")]
                        )
                      : _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "info",
                              size: "medium",
                              effect: "dark",
                            },
                          },
                          [_vm._v("否")]
                        ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm.form.couponTag
                ? _c("div", { staticClass: "info-item" }, [
                    _c("label", { staticClass: "info-label" }, [
                      _vm._v("优惠券标签"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "info-value" },
                      [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "primary",
                              size: "medium",
                              effect: "dark",
                            },
                          },
                          [_vm._v(_vm._s(_vm.form.couponTag))]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.form.areaValidationFailMsg
                ? _c("div", { staticClass: "info-item full-width" }, [
                    _c("label", { staticClass: "info-label" }, [
                      _vm._v("地区验证失败提示语"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-value" }, [
                      _vm._v(_vm._s(_vm.form.areaValidationFailMsg)),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _vm.hasRangeConfig
            ? _c("div", { staticClass: "detail-section" }, [
                _vm._m(6),
                _vm._v(" "),
                _c("div", { staticClass: "info-grid" }, [
                  _vm.getRangeConfigItem("selfOperatedCardVouchers").length > 0
                    ? _c("div", { staticClass: "info-item full-width" }, [
                        _c("label", { staticClass: "info-label" }, [
                          _vm._v("自营卡券商品"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "info-value" },
                          _vm._l(
                            _vm.getRangeConfigItem("selfOperatedCardVouchers"),
                            function (item, index) {
                              return _c(
                                "el-tag",
                                {
                                  key: index,
                                  staticStyle: {
                                    "margin-right": "10px",
                                    "margin-bottom": "8px",
                                  },
                                  attrs: {
                                    size: "medium",
                                    type: "primary",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-goods",
                                    staticStyle: { "margin-right": "4px" },
                                  }),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }
                          ),
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getRangeConfigItem("onlineOrderingBrands").length > 0
                    ? _c("div", { staticClass: "info-item full-width" }, [
                        _c("label", { staticClass: "info-label" }, [
                          _vm._v("在线点餐品牌"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "info-value" },
                          _vm._l(
                            _vm.getRangeConfigItem("onlineOrderingBrands"),
                            function (item, index) {
                              return _c(
                                "el-tag",
                                {
                                  key: index,
                                  staticStyle: {
                                    "margin-right": "10px",
                                    "margin-bottom": "8px",
                                  },
                                  attrs: {
                                    size: "medium",
                                    type: "success",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-food",
                                    staticStyle: { "margin-right": "4px" },
                                  }),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }
                          ),
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getRangeConfigItem("verificationStoresMerchants").length >
                  0
                    ? _c("div", { staticClass: "info-item full-width" }, [
                        _c("label", { staticClass: "info-label" }, [
                          _vm._v("核销门店商家"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "info-value" },
                          _vm._l(
                            _vm.getRangeConfigItem(
                              "verificationStoresMerchants"
                            ),
                            function (item, index) {
                              return _c(
                                "el-tag",
                                {
                                  key: index,
                                  staticStyle: {
                                    "margin-right": "10px",
                                    "margin-bottom": "8px",
                                  },
                                  attrs: {
                                    size: "medium",
                                    type: "warning",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-s-shop",
                                    staticStyle: { "margin-right": "4px" },
                                  }),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }
                          ),
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getRangeConfigItem("verificationStores").length > 0
                    ? _c("div", { staticClass: "info-item full-width" }, [
                        _c("label", { staticClass: "info-label" }, [
                          _vm._v("核销门店"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "info-value" },
                          _vm._l(
                            _vm.getRangeConfigItem("verificationStores"),
                            function (item, index) {
                              return _c(
                                "el-tag",
                                {
                                  key: index,
                                  staticStyle: {
                                    "margin-right": "10px",
                                    "margin-bottom": "8px",
                                  },
                                  attrs: {
                                    size: "medium",
                                    type: "warning",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-office-building",
                                    staticStyle: { "margin-right": "4px" },
                                  }),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }
                          ),
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getRangeConfigItem("gasStationStores").length > 0
                    ? _c("div", { staticClass: "info-item full-width" }, [
                        _c("label", { staticClass: "info-label" }, [
                          _vm._v("加油门店"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "info-value" },
                          _vm._l(
                            _vm.getRangeConfigItem("gasStationStores"),
                            function (item, index) {
                              return _c(
                                "el-tag",
                                {
                                  key: index,
                                  staticStyle: {
                                    "margin-right": "10px",
                                    "margin-bottom": "8px",
                                  },
                                  attrs: {
                                    size: "medium",
                                    type: "danger",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-s-marketing",
                                    staticStyle: { "margin-right": "4px" },
                                  }),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }
                          ),
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getRangeConfigItem("renshouMerchants").length > 0
                    ? _c("div", { staticClass: "info-item full-width" }, [
                        _c("label", { staticClass: "info-label" }, [
                          _vm._v("仁寿网店商家"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "info-value" },
                          _vm._l(
                            _vm.getRangeConfigItem("renshouMerchants"),
                            function (item, index) {
                              return _c(
                                "el-tag",
                                {
                                  key: index,
                                  staticStyle: {
                                    "margin-right": "10px",
                                    "margin-bottom": "8px",
                                  },
                                  attrs: {
                                    size: "medium",
                                    type: "info",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-s-home",
                                    staticStyle: { "margin-right": "4px" },
                                  }),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }
                          ),
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getRangeConfigItem("renshouStores").length > 0
                    ? _c("div", { staticClass: "info-item full-width" }, [
                        _c("label", { staticClass: "info-label" }, [
                          _vm._v("仁寿门店"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "info-value" },
                          _vm._l(
                            _vm.getRangeConfigItem("renshouStores"),
                            function (item, index) {
                              return _c(
                                "el-tag",
                                {
                                  key: index,
                                  staticStyle: {
                                    "margin-right": "10px",
                                    "margin-bottom": "8px",
                                  },
                                  attrs: {
                                    size: "medium",
                                    type: "success",
                                    effect: "dark",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-office-building",
                                    staticStyle: { "margin-right": "4px" },
                                  }),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }
                          ),
                          1
                        ),
                      ])
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.form.applicableNotice || _vm.form.applicableScope
            ? _c("div", { staticClass: "detail-section" }, [
                _vm._m(7),
                _vm._v(" "),
                _c("div", { staticClass: "info-grid" }, [
                  _vm.form.applicableNotice
                    ? _c("div", { staticClass: "info-item full-width" }, [
                        _c("label", { staticClass: "info-label" }, [
                          _vm._v("适用须知"),
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "info-value rich-text-content",
                          domProps: {
                            innerHTML: _vm._s(_vm.form.applicableNotice),
                          },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.applicableScope
                    ? _c("div", { staticClass: "info-item full-width" }, [
                        _c("label", { staticClass: "info-label" }, [
                          _vm._v("适用范围"),
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "info-value rich-text-content",
                          domProps: {
                            innerHTML: _vm._s(_vm.form.applicableScope),
                          },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.form.applicableNotice && !_vm.form.applicableScope
                    ? _c("div", { staticClass: "info-item full-width" }, [
                        _vm._m(8),
                      ])
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("CopyLinkVue", { ref: "CopyLinkVueRef" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("i", { staticClass: "el-icon-info section-icon" }),
      _vm._v(" "),
      _c("span", { staticClass: "section-title" }, [_vm._v("基本信息")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("i", { staticClass: "el-icon-time section-icon" }),
      _vm._v(" "),
      _c("span", { staticClass: "section-title" }, [_vm._v("时间信息")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("i", { staticClass: "el-icon-discount section-icon" }),
      _vm._v(" "),
      _c("span", { staticClass: "section-title" }, [_vm._v("优惠信息")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("i", { staticClass: "el-icon-link section-icon" }),
      _vm._v(" "),
      _c("span", { staticClass: "section-title" }, [_vm._v("相关链接")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("i", { staticClass: "el-icon-shopping-cart-full section-icon" }),
      _vm._v(" "),
      _c("span", { staticClass: "section-title" }, [_vm._v("适用范围")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("i", { staticClass: "el-icon-setting section-icon" }),
      _vm._v(" "),
      _c("span", { staticClass: "section-title" }, [_vm._v("配置信息")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("i", { staticClass: "el-icon-s-operation section-icon" }),
      _vm._v(" "),
      _c("span", { staticClass: "section-title" }, [_vm._v("范围配置详情")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-header" }, [
      _c("i", { staticClass: "el-icon-document section-icon" }),
      _vm._v(" "),
      _c("span", { staticClass: "section-title" }, [_vm._v("适用说明")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-value" }, [
      _c("i", { staticClass: "el-icon-info-circle" }),
      _vm._v(" "),
      _c("span", [_vm._v("暂无适用说明")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }